import { render, staticRenderFns } from "./SvPrivacyPolicy.vue?vue&type=template&id=41065a54&scoped=true"
import script from "./SvPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./SvPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "41065a54",
  null
  ,true
)

export default component.exports